import { render, staticRenderFns } from "./ContributionLevelIcon.vue?vue&type=template&id=2b2fe904"
import script from "./contribution-level-icon.ts?vue&type=script&lang=ts&external"
export * from "./contribution-level-icon.ts?vue&type=script&lang=ts&external"
import style0 from "./contribution-level-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports